module.exports = __webpack_public_path__ + "img/ic_20_download.b615d762.svg";